// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3zvfn","colMaxWidth":"Table_colMaxWidth___qoc4"};